<template>
  <div>
    <Nav />
    <section class="section" id="Main" role="main">
      <div class="container">
        <h2 class="title is-2">Workshops</h2>

        <h3 class="title is-3">Overview</h3>
        <p>This all-day workshop will support elementary and middle school central Texas teachers and staff in teaching about Texas slavery and race. The workshop will equip teachers with content, curricula materials, and teaching strategies to strengthen students’ understanding of Texas slavery from a robust, critical, and humanizing standpoint. Workshops will be facilitated by an historian, researchers of curriculum and teaching, an archivist, and former K-8 teachers and curriculum specialists.</p>
        <hr />
        <h3 class="title is-3">Upcoming Workshops</h3>

        <div class="content">
          <p>The Texas Slavery Project is offering workshops to school districts across the state. Please contact us for more information.</p>
        </div>

        <hr />
        <div class="request">
          <a
            class="button is-large is-danger"
            href="mailto:drb@austin.utexas.edu,ALB@austin.utexas.edu,keffrelyn@austin.utexas.edu?subject=Request for Teaching Texas Slavery Workshop"
            aria-label="Contact the project leads to schedule a workshop"
          >
            <span class="icon">
              <i class="fas fa-calendar-alt"></i>
            </span>
            <span>Request a Workshop</span>
          </a>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import Workshop from "./components/Workshop.vue";

export default {
  name: "Records",
  components: {
    Nav,
    Footer,
    Workshop
  }
};
</script>

<style scoped>
.request {
  text-align: center;
}
</style>